import { useEffect, useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { useSession } from "@/state/session";

const LINKS = [
  { to: "/home", label: "Home" },
  { to: "/browse", label: "Browse" },
  { to: "/search", label: "Search" },
  { to: "/watchlist", label: "My List" },
];

export function TopNav() {
  const { profile, signOut } = useSession();
  const navigate = useNavigate();
  const [solid, setSolid] = useState(false);

  useEffect(() => {
    const onScroll = () => setSolid(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <nav className={solid ? "nav nav--solid" : "nav"}>
      <Link to="/home" className="nav__brand">
        Hayfish
      </Link>
      <div className="nav__links">
        {LINKS.map((link) => (
          <NavLink
            key={link.to}
            to={link.to}
            className={({ isActive }) => (isActive ? "is-active" : undefined)}
          >
            {link.label}
          </NavLink>
        ))}
      </div>
      <div className="nav__spacer" />
      <div className="nav__actions">
        <Link to="/profiles" className="btn btn--quiet">
          {profile?.name ?? "Profiles"}
        </Link>
        <Link to="/account" aria-label="Account">
          <span className="avatar">{(profile?.name ?? "H").slice(0, 1).toUpperCase()}</span>
        </Link>
        <button
          type="button"
          className="btn btn--quiet"
          onClick={() => {
            signOut();
            navigate("/");
          }}
        >
          Sign out
        </button>
      </div>
    </nav>
  );
}
